import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-coming-soon-dialog',
  templateUrl: './coming-soon-dialog.component.html',
  styleUrls: ['./coming-soon-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule],
})
export class ComingSoonDialogComponent implements OnInit {
  private userEmail: string;

  constructor(
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    this.userEmail = this.config.data?.userEmail || '';
  }

  ngOnInit(): void {}

  /**
   * Marks the banner as seen for this specific user
   */
  closeDialog(): void {
    if (this.userEmail) {
      // Get existing users who have seen the banner
      const seenBannerUsers = this.getSeenBannerUsers();

      // Add current user to the list
      seenBannerUsers[this.userEmail] = true;

      // Save back to localStorage
      localStorage.setItem('comingSoonBannerSeen_v2', JSON.stringify(seenBannerUsers));
    }

    this.ref.close();
  }

  /**
   * Gets the map of users who have seen the banner
   */
  private getSeenBannerUsers(): Record<string, boolean> {
    const seenBannerJson = localStorage.getItem('comingSoonBannerSeen_v2');
    if (seenBannerJson) {
      try {
        return JSON.parse(seenBannerJson);
      } catch (e) {
        // Reset if invalid format
        return {};
      }
    }
    return {};
  }
}
